<template>
  <div class="rc-l-public rc-l-public--subscription">
    <div class="rc-l-public--title">
      <div class="container">
        <h1 class="mx-auto">{{ $t("statics.subscription.title") }}</h1>
      </div>
    </div>
    <!-- section 1 : Curio offers (list)-->
    <section>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-xl-8 rc-col-text">
            <h2
              v-html="$t('statics.subscription.section1.title')"
              class="text-center mx-auto"
            ></h2>
            <p
              class="rc-intro--xl text-center mx-auto"
              v-html="$t('statics.subscription.section1.text')"
            ></p>
            <div class="row rc-wrapper-list-check">
              <div
                class="col-xs-12 col-sm-8 col-md-6 offset-sm-2 offset-md-0 rc-col-max-width"
              >
                <ul class="rc-list-check">
                  <li v-html="$t('statics.subscription.section1.list.1')"></li>
                  <li v-html="$t('statics.subscription.section1.list.2')"></li>
                  <li v-html="$t('statics.subscription.section1.list.3')"></li>
                  <li v-html="$t('statics.subscription.section1.list.4')"></li>
                  <li v-html="$t('statics.subscription.section1.list.5')"></li>
                  <li v-html="$t('statics.subscription.section1.list.6')"></li>
                </ul>
              </div>
              <div
                class="col-xs-12 col-sm-8 col-md-6 offset-sm-2 offset-md-0 rc-col-max-width"
              >
                <ul class="rc-list-check">
                  <li v-html="$t('statics.subscription.section1.list.7')"></li>
                  <li v-html="$t('statics.subscription.section1.list.8')"></li>
                  <li v-html="$t('statics.subscription.section1.list.9')"></li>
                  <li v-html="$t('statics.subscription.section1.list.10')"></li>
                  <li v-html="$t('statics.subscription.section1.list.11')"></li>
                  <li v-html="$t('statics.subscription.section1.list.12')"></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- section 2 : Curio adapts to your needs (table)-->
    <section class="bg-yellow">
      <div class="container">
        <div class="row text-center">
          <div class="col rc-col-text pb-0">
            <h2
              class="text-center mx-auto"
              v-html="$t('statics.subscription.section2.title')"
            ></h2>
            <p
              class="rc-intro--xl text-center mx-auto"
              v-html="$t('statics.subscription.section2.text')"
            ></p>
          </div>
        </div>
        <div class="row text-center">
          <div class="col">
            <div class="rc-table-inclusions table-responsive">
              <table role="table" class="table b-table table-borderless">
                <thead role="rowgroup">
                  <tr role="row">
                    <th class="bg-yellow" role="columnheader" scope="col"></th>
                    <th class="bg-yellow" role="columnheader" scope="col">
                      {{ $t("statics.subscription.section2.tableCol.1") }}
                    </th>
                    <th class="bg-yellow" role="columnheader" scope="col">
                      {{ $t("statics.subscription.section2.tableCol.2") }}
                    </th>
                    <th class="bg-yellow" role="columnheader" scope="col">
                      {{ $t("statics.subscription.section2.tableCol.3") }}
                    </th>
                    <th class="bg-yellow" role="columnheader" scope="col">
                      {{ $t("statics.subscription.section2.tableCol.4") }}
                    </th>
                  </tr>
                </thead>
                <tbody role="rowgroup">
                  <tr role="row">
                    <th class="bg-yellow" role="rowheader" scope="row">
                      {{ $t("statics.subscription.section2.tableRow.1") }}
                    </th>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                  </tr>
                  <tr role="row">
                    <th class="bg-yellow" role="rowheader" scope="row">
                      {{ $t("statics.subscription.section2.tableRow.2") }}
                    </th>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                  </tr>

                  <tr role="row">
                    <th class="bg-yellow" role="rowheader" scope="row">
                      {{ $t("statics.subscription.section2.tableRow.3") }}
                    </th>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                  </tr>
                  <tr role="row">
                    <th class="bg-yellow" role="rowheader" scope="row">
                      {{ $t("statics.subscription.section2.tableRow.4") }}
                    </th>
                    <td class="bg-yellow" role="cell">
                      <span class="visually-hidden">{{
                        $t("common.not_included")
                      }}</span>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <span class="visually-hidden">{{
                        $t("common.not_included")
                      }}</span>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                  </tr>
                  <tr role="row">
                    <th class="bg-yellow" role="rowheader" scope="row">
                      {{ $t("statics.subscription.section2.tableRow.5") }}
                    </th>
                    <td class="bg-yellow" role="cell">
                      <span class="visually-hidden">{{
                        $t("common.not_included")
                      }}</span>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                  </tr>
                  <tr role="row">
                    <th class="bg-yellow" role="rowheader" scope="row">
                      {{ $t("statics.subscription.section2.tableRow.6") }}
                    </th>
                    <td class="bg-yellow" role="cell">
                      <span class="visually-hidden">{{
                        $t("common.not_included")
                      }}</span>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                  </tr>
                  <tr role="row">
                    <th class="bg-yellow" role="rowheader" scope="row">
                      {{ $t("statics.subscription.section2.tableRow.7") }}
                    </th>
                    <td class="bg-yellow" role="cell">
                      <span class="visually-hidden">{{
                        $t("common.not_included")
                      }}</span>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <span class="visually-hidden">{{
                        $t("common.not_included")
                      }}</span>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                  </tr>
                  <tr role="row">
                    <th class="bg-yellow" role="rowheader" scope="row">
                      {{ $t("statics.subscription.section2.tableRow.8") }}
                    </th>
                    <td class="bg-yellow" role="cell">
                      <span class="visually-hidden">{{
                        $t("common.not_included")
                      }}</span>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <span class="visually-hidden">{{
                        $t("common.not_included")
                      }}</span>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <span class="visually-hidden">{{
                        $t("common.not_included")
                      }}</span>
                    </td>
                    <td class="bg-yellow" role="cell">
                      <rc-icon
                        name="check"
                        scale="1"
                        :title="$t('common.included')"
                      ></rc-icon>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- section 3 : Subscription-->
    <section class="rc-bg-wave-plum-2">
      <div class="container">
        <div class="row">
          <div class="col-md-7 col-xl-6 rc-col-text rc-col-max-width">
            <h2 v-html="$t('statics.subscription.section3.title')"></h2>
            <p
              class="rc-intro--xl"
              v-html="$t('statics.subscription.section3.text')"
            ></p>

            <h3
              class="mt-4"
              v-html="$t('statics.subscription.section3.list.title')"
            ></h3>
            <ul class="rc-list-bullet">
              <li v-html="$t('statics.subscription.section3.list.1')"></li>
              <li v-html="$t('statics.subscription.section3.list.2')"></li>
              <li v-html="$t('statics.subscription.section3.list.3')"></li>
              <li v-html="$t('statics.subscription.section3.list.4')"></li>
              <li v-html="$t('statics.subscription.section3.list.5')"></li>
            </ul>
          </div>
          <div class="col-md-5">
            <img
              src="/src/assets/img/illustrations/airplane_combined.svg"
              class="rc-airplane-combined"
              alt=""
            />
          </div>
        </div>
      </div>
    </section>
    <!-- section 4 : Channels-->
    <section class="rc-channels rc-section-last">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 col-xl-5 rc-col-text">
            <ul class="rc-list-logos">
              <li>
                <img
                  src="/src/assets/img/logos/lg_curioinfo.png"
                  alt="Curio Info"
                  class="rc-lg-curio-info"
                />
              </li>
              <li>
                <img
                  src="/src/assets/img/logos/lg_newsinreview.png"
                  alt="News in Review"
                  class="rc-lg-news-in-review"
                />
              </li>
              <li>
                <img
                  src="/src/assets/img/logos/lg_bbc.png"
                  alt="BBC"
                  class="rc-lg-bbc"
                />
              </li>
              <li>
                <img
                  src="/src/assets/img/logos/lg_natgeo.png"
                  alt="National Geographic"
                  class="rc-lg-natgeo"
                />
              </li>
            </ul>
          </div>
          <div class="col-md-6 rc-col-text rc-col-max-width">
            <h2 v-html="$t('statics.subscription.section4.title')"></h2>
            <p
              class="rc-intro--xl"
              v-html="$t('statics.subscription.section4.text')"
            ></p>
            <router-link :to="toMarketChannels" class="btn btn-dark btn-lg">{{
              $t("statics.subscription.section4.cta")
            }}</router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- section 5 : A valued ressource form coast to coast (logos) -->
    <section class="d-none">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-8 text-center rc-col-text">
            <h2 v-html="$t('statics.subscription.section5.title')"></h2>
            <ul class="rc-list-logos">
              <li>
                <img
                  src="/src/assets/img/logos/lg_qc_education_enseignement_superieur.svg"
                  alt="Éducation et Enseignement supérieur du Québec"
                />
              </li>
              <li>
                <img
                  src="/src/assets/img/logos/lg_on_ministry_education.svg"
                  alt="Ministry of Education Ontario"
                />
              </li>
              <li>
                <img
                  src="/src/assets/img/logos/lg_bc_ministry_education.svg"
                  alt="Ministry of Education British Columbia"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RcIcon from "@/libvue/components/icons/Base.vue";
import { navMixin } from "#/routes/mixins";
export default {
  name: "RcSiteSubscriptionLanding",
  components: {
    RcIcon
  },
  mixins: [navMixin]
};
</script>

<style lang="scss"></style>
